import { render } from "./ReplaceLinks.vue?vue&type=template&id=1db669a2"
import script from "./ReplaceLinks.vue?vue&type=script&lang=js"
export * from "./ReplaceLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__